import { createContext, useContext } from 'react'
import type { InsuranceMe } from './api'

/** Who is signed in, and which of the insurer's desks they work. */
export type Session = { account: string; me?: InsuranceMe }
export const SessionContext = createContext<Session>({ account: '' })
export const useSession = () => useContext(SessionContext)

/** Anyone on the insurer's side sees every policy and claim, not only their own. */
export const isStaff = (me?: InsuranceMe) =>
  !!me?.staff && (me.staff.underwriter || me.staff.claims || me.staff.actuary)
